// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-side-panel-container-visible {
  border-left: 1px solid var(--border-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/side-panels/right-side-panel/RightSidePanel.component.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;AACvD","sourcesContent":[".right-side-panel-container-visible {\n  border-left: 1px solid var(--border-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
